


























































































































































































































































import Vue from "vue";
import SingleBlock from "@/components/travel_planning/SingleBlock.vue";
export default Vue.extend({
  components: {
    SingleBlock,
  },
  data() {
    return {
      chartSettings: {
        stack: {
          xxx: ["cost", "profit"],
        },
      },
      stackedChartSettings: {
        stack: {
          xxx: ["bus", "car", "train", "walk", "bike"],
        },
        colors: ["red"],
      },
      radiusChartSettings: {
        label: {
          normal: {
            show: false,
            position: "center",
          },
        },
        // roseType: "radius",
      },
    };
  },
  computed: {
    chartData: function () {
      if (this.stats) {
        return {
          columns: ["type", "value"],
          rows: [
            { type: "diesel", value: this.stats.carsData.diesel },
            { type: "petrol", value: this.stats.carsData.petrol },
            { type: "hybrid", value: this.stats.carsData.hybrid },
            { type: "electric", value: this.stats.carsData.electric },
          ],
        };
      } else {
        return null;
      }
    },
    electricHybrid: function () {
      if (this.stats) {
        const cardData = this.stats.carsData;
        const total =
          cardData.diesel +
          cardData.petrol +
          cardData.hybrid +
          cardData.electric;
        return (((cardData.hybrid + cardData.electric) / total) * 100).toFixed(
          1
        );
      } else {
        return null;
      }
    },
    underAmile: function () {
      if (this.stats) {
        const total =
          this.stats.underAmile["UNDER A MILE"] +
          this.stats.underAmile["OVER A MILE"];
        return ((this.stats.underAmile["UNDER A MILE"] / total) * 100).toFixed(
          1
        );
      } else {
        return null;
      }
    },
    under2miles: function () {
      if (this.stats) {
        const total =
          this.stats.under2miles["OVER 1.5 MILES"] +
          this.stats.under2miles["UNDER 1.5 MILES"];
        return (
          (this.stats.under2miles["UNDER 1.5 MILES"] / total) *
          100
        ).toFixed(1);
      } else {
        return null;
      }
    },
  },
  props: ["stats"],
});
